import React from "react";
import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/use-auth-simple";
import { ProtectedRoute } from "@/lib/protected-route";
import { AdminProtectedRoute } from "@/lib/admin-protected-route";
import ErrorBoundary from "@/components/ErrorBoundary";
import NotFound from "@/pages/not-found";
import AuthPage from "@/pages/auth-page";
import ChatPage from "@/pages/chat-page";
import AdminPage from "@/pages/admin-page";
import ResponseHub from "@/pages/response-hub";
import LibraryPage from "@/pages/library-page";
import DocumentViewerPage from "@/pages/document-viewer-page";
import ProjectDevelopmentPage from "@/pages/project-development-page";
import ProjectIdeaDetailPage from "@/pages/project-idea-detail-page";
import FeatureRequestsPage from "@/pages/feature-requests-page";
import GuidelinesListPage from "@/pages/guidelines-list-page";
import GuidelineDetailPage from "@/pages/guideline-detail-page";
import { ThemeProvider } from "next-themes";

function Router() {
  return (
    <Switch>
      <ProtectedRoute path="/" component={ChatPage} />
      <ProtectedRoute path="/admin" component={AdminPage} />
      <AdminProtectedRoute path="/project-development" component={ProjectDevelopmentPage} />
      <AdminProtectedRoute path="/project-development/project/:id" component={ProjectIdeaDetailPage} />
      <ProtectedRoute path="/feature-requests" component={FeatureRequestsPage} />
      <AdminProtectedRoute path="/guidelines" component={GuidelinesListPage} />
      <AdminProtectedRoute path="/guidelines/:id" component={GuidelineDetailPage} />
      <ProtectedRoute path="/response-hub" component={ResponseHub} />
      <ProtectedRoute path="/library" component={LibraryPage} />
      <ProtectedRoute path="/documents/:id" component={DocumentViewerPage} />
      <Route path="/auth" component={AuthPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  console.log('App component rendering...');
  
  try {
    return (
      <ErrorBoundary>
        <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <TooltipProvider>
                <Toaster />
                <Router />
              </TooltipProvider>
            </AuthProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </ErrorBoundary>
    );
  } catch (error) {
    console.error('Error in App component:', error);
    return (
      <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
        <h1>App Error</h1>
        <p>Error in App component: {error.message}</p>
        <button onClick={() => window.location.reload()}>Reload Page</button>
      </div>
    );
  }
}

export default App;
